// removed by extract-text-webpack-plugin
module.exports = {"Label":"_3YVO1","CheckInput":"_2y-lS","Checkmark":"_2kebn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/CommonCheckBox/CommonCheckBox.scss
// module id = 371
// module chunks = 0